import { useQuery } from "@tanstack/react-query";
import apiClient from "@/modules/request.module.v2";

const useCompanySearch = (query) => {
  const normalizedQuery = query?.trim() || "";

  return useQuery({
    queryKey: ["synaCompanySearch", normalizedQuery],
    enabled: normalizedQuery.length >= 3,
    retry: false,
    queryFn: async () => {
      const response = await apiClient.get("/syna-integration/companies", {
        params: { q: normalizedQuery },
      });

      if (!Array.isArray(response?.data)) {
        return [];
      }

      return response.data.map((company) => ({
        value: company.orgNumber,
        label: company.name,
      }));
    },
  });
};

export { useCompanySearch };
